import { styled } from "@mui/material";
import clsx from "clsx";
import TabButton from "./TabButton";

const TabsStyled = styled("div")({
  "&.tabs-component-wrapper": {
    display: "flex",
    gap: "4px",
  },
  "&.start": {
    justifyContent: "flex-start",
  },
  "&.center": {
    justifyContent: "center",
  },
  "&.even": {
    justifyContent: "space-evenly",
  },
  "&.end": {
    justifyContent: "flex-end",
  },
});

/**
 *
 * @param {Object} props
 * @param {String|Number} props.value - current selected tab value
 * @param {Function} props.setValue - function to set the selected tab value
 * @param {Array} props.tabs - array of tab objects {value, label}
 * @param {Object} props.classNames - object of classNames for customization {wrapper, button, ...}
 * @param {String} props.className - additional className for the wrapper
 * @param {'outlined' | 'underline'} props.variant - tab button variant 'outlined' | 'underline'
 * @param {'start' | 'center' | 'even' | 'end'} props.spacing - spacing of the tabs 'start' | 'center' | 'even' | 'end'
 * @returns
 */
const TabsUnstyled = ({
  value,
  setValue,
  tabs = [],
  classNames = {},
  className,
  variant = "outlined",
  spacing = "start",
}) => {
  const { wrapper: wrapperClassname, ...btnClassnames } = classNames;
  return (
    <TabsStyled
      className={clsx(
        "tabs-component-wrapper",
        spacing,
        wrapperClassname,
        className
      )}
    >
      {tabs.map((tab) => (
        <TabButton
          key={tab.value}
          isSelected={tab.value === value}
          variant={variant}
          classNames={btnClassnames}
          onClick={() => setValue(tab.value)}
        >
          {tab.label}
        </TabButton>
      ))}
    </TabsStyled>
  );
};
const Tabs = styled(TabsUnstyled)({});

export default Tabs;
